import "./App.css";
import { useEffect } from "react";
import Calendar from "./Components/Calendar";

function App() {
  return (
    <div className="App">
      <Calendar />
    </div>
  );
}

export default App;
